export const DEFAULT_NUM_VIEWED_PRODUCTS_UNTIL_PANEL_OPEN = 3;
export const DEFAULT_PANEL_TITLE = "Save these for later?";
export const DEFAULT_PANEL_MESSAGE =
  "Automatically save these items for later inside your account.";
